import React, { createContext } from 'react';
import PropTypes from 'prop-types';

const ValuesContext = createContext({
  values: {},
  loading: false,
  setValue: () => {},
});
const ErrorsContext = createContext({
  errors: {},
  setError: () => {},
});

class Form extends React.Component {
  state = {
    values: this.props.defaultValues,
    errors: {},
    loading: false,
  };

  setValue = (name, value) => {
    this.setState((prevState) => ({
      values: {
        ...prevState.values,
        [name]: value,
      },
    }));
  };

  setLoading = (loading) => {
    this.setState({ loading });
  };

  setError = (name, message) => {
    this.setState((prevState) => {
      const { errors: currErrors } = prevState;
      let errors = currErrors;

      if (!message) {
        if (currErrors[name]) {
          delete currErrors[name];
          errors = currErrors;
        }
      } else {
        errors = {
          ...currErrors,
          [name]: message,
        };
      }

      return { errors };
    });
  };

  render() {
    const { values, errors } = this.state;

    return (
      <ValuesContext.Provider value={{ values, setValue: this.setValue, setLoading: this.setLoading }}>
        <ErrorsContext.Provider value={{ errors, setError: this.setError }}>
          <form method="post" id="mtm-form" className={this.state.loading ? 'loading' : null}>
            {this.props.children}
          </form>
        </ErrorsContext.Provider>
      </ValuesContext.Provider>
    );
  }
}

Form.propTypes = {
  children: PropTypes.node,
  defaultValues: PropTypes.object,
};

Form.defaultProps = {
  defaultValues: {},
};

export function FormConsumer({ children }) {
  return (
    <ErrorsContext.Consumer>
      {(errorsContext) => (
        <ValuesContext.Consumer>
            {(valuesContext) => children({ ...errorsContext, ...valuesContext })}
        </ValuesContext.Consumer>
      )}
    </ErrorsContext.Consumer>
  );
};

export default Form;



// WEBPACK FOOTER //
// ./src/Form/index.js